export default __webpack_public_path__ + "static/media/message-translate.80731563.svg";